import React from'react';
import './index.css';
const Footer=()=>{
    return(
        <><div className='container'>
        
      
<footer className="footer-clr page-footer font-small special-color-dark pt-4 ">
<h4 className='text-center text-dark'>Follow me on..</h4>
 
  <div className="container ">
       
  
    <ul className="list-unstyled list-inline text-center">
   
      <li className="list-inline-item">
        <a className="btn-floating btn-fb mx-1" href='https://www.instagram.com/invites/contact/?i=1xpzlfy2fd8nz&utm_content=8r1mc9z' target="_er-manish-gupta">
        <i className="fab fa-instagram fa-2x"></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a className="btn-floating btn-tw mx-1" href='https://m.facebook.com/profile.php?lst=100034455130181%3A100034455130181%3A1641045381' target="_er-manish-gupta">
          <i className="fab fa-facebook fa-2x"> </i>
        </a>
      </li>
     
      <li className="list-inline-item">
        <a className="btn-floating btn-li mx-1">
          <i className="fab fa-linkedin-in fa-2x"> </i>
        </a>
      </li>
      <li className="list-inline-item">
        <a className="btn-floating btn-dribbble mx-1">
        <i class="fab fa-twitter fa-2x"></i>
        </a>
      </li>
    </ul>
   

  </div>
  
  <div className="footer-copyright text-center py-3 text-dark bg-black">© 2020 Copyright:
    <a href=""> Er.manishgupta.com</a>
  </div>

</footer>

</div>

        </>
    )
}
 
export default Footer;